/*
  Expandura – Cart-Open-Bridge + Fehler-Selbstheilung + Geschenk-Schutz

  UX-Entscheidung (01.09.2026, Willi): NICHT den Drawer sofort leer/weiß
  öffnen, sondern den "In den Warenkorb legen"-Button in einen Ladezustand
  versetzen (Spinner im Button) und den Drawer erst öffnen, wenn der fertige
  Inhalt da ist — dann ploppt er komplett gefüllt auf.

  Technik:
  1) Beim Absenden des Add-Requests bekommt der geklickte Button einen
     Spinner (Text unsichtbar, weißer Kreis, Klicks gesperrt).
  2) Der Add-Request (JSON-Body) wird um `sections` erweitert, sodass Shopify
     den fertigen Drawer-HTML direkt in DERSELBEN Antwort mitliefert —
     kein zweiter Abruf. renderContents() öffnet den Drawer mit Inhalt.
  3) Fängt sporadische Warenkorb-Fehler ab ("Parameter line ist ungültig"):
     Meldung entfernen + neu rendern.
  4) Geschenk-Schutz: Sobald KEIN bezahlter Expandura mehr im Warenkorb liegt,
     werden die Gratis-Geschenke (€0-Zeilen mit Property "Geschenk") automatisch
     entfernt. Entfernen läuft über /cart/update.js per Line-KEY.
  5) Feuert `ex:cart-mutated` nach jeder Warenkorb-Änderung — darauf hören die
     Geschenk-Wächter der Offer-Widgets (ersetzt deren früheres 2s-Polling).
*/
(function () {
  if (window.__exCartBridge) return;
  window.__exCartBridge = true;

  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  var timer = null;
  var lastHeal = 0;
  var ladeKnopf = null;
  var knopfTimer = null;
  var letzterKnopf = null;
  var letzterKlick = 0;

  /* iOS-Safari fokussiert Buttons beim Tippen NICHT — deshalb den zuletzt
     geklickten Button selbst mitschreiben statt auf activeElement zu bauen. */
  try {
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('button') : null;
      if (b) { letzterKnopf = b; letzterKlick = Date.now(); }
    }, true);
  } catch (e) {}

  function base() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  }

  function drawerEl() {
    return document.querySelector('cart-drawer');
  }

  /* --- Ladezustand im geklickten Button, solange der Inhalt unterwegs ist --- */
  function knopfCss() {
    if (document.getElementById('ex-btn-laden-css')) return;
    var s = document.createElement('style');
    s.id = 'ex-btn-laden-css';
    s.textContent =
      'button.ex-btn-laden{color:transparent!important;pointer-events:none;position:relative}' +
      'button.ex-btn-laden::after{content:"";position:absolute;top:50%;left:50%;width:18px;height:18px;margin:-9px 0 0 -9px;border:2px solid rgba(255,255,255,.35);border-top-color:#fff;border-radius:50%;animation:exspin .6s linear infinite}' +
      '@keyframes exspin{to{transform:rotate(360deg)}}';
    document.head.appendChild(s);
  }

  function knopfAn() {
    var el = (letzterKnopf && Date.now() - letzterKlick < 3000) ? letzterKnopf : document.activeElement;
    if (el && el.tagName === 'BUTTON') {
      knopfCss();
      ladeKnopf = el;
      el.classList.add('ex-btn-laden');
      clearTimeout(knopfTimer);
      knopfTimer = setTimeout(knopfAus, 6000); // Sicherheitsnetz
    }
  }

  function knopfAus() {
    clearTimeout(knopfTimer);
    if (ladeKnopf) {
      ladeKnopf.classList.remove('ex-btn-laden');
      ladeKnopf = null;
    }
  }

  /* --- Inhalt aus fertigen Sections rendern; renderContents() öffnet den
         Drawer selbst — mit dem Inhalt schon drin. --- */
  function renderSections(sections) {
    var drawer = drawerEl();
    if (!drawer || !sections) return false;
    try {
      drawer.renderContents({ sections: sections });
      if (drawer.querySelector('.cart-item')) {
        drawer.classList.remove('is-empty');
      } else {
        drawer.classList.add('is-empty');
      }
      return true;
    } catch (e) {
      return false;
    }
  }

  /* --- Fallback: Sections separat holen, dann öffnen --- */
  function render() {
    var drawer = drawerEl();
    if (!drawer) return;
    fetch(base() + '?sections=' + SECTIONS, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (!renderSections(sections)) {
          if (typeof drawer.open === 'function') drawer.open();
        }
        knopfAus();
      })
      .catch(function () {
        knopfAus();
        if (typeof drawer.open === 'function') drawer.open();
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(render, 50);
  }

  /* --- Add-Request um `sections` erweitern (nur JSON-Bodys) --- */
  function mitSections(init) {
    try {
      if (!init || typeof init.body !== 'string') return init;
      var obj = JSON.parse(init.body);
      if (!obj || typeof obj !== 'object' || obj.sections) return init;
      obj.sections = SECTIONS;
      obj.sections_url = window.location.pathname;
      var neu = {};
      for (var k in init) neu[k] = init[k];
      neu.body = JSON.stringify(obj);
      return neu;
    } catch (e) {
      return init;
    }
  }

  /* Signal an die Offer-Widgets: Warenkorb hat sich geändert (ersetzt deren
     frueheres 2-Sekunden-Polling — der Geschenk-Waechter laeuft nur noch dann). */
  function melden() {
    try { document.dispatchEvent(new CustomEvent('ex:cart-mutated', { bubbles: true })); } catch (e) {}
  }

  function cleanupOrphanGifts() {
    if (window.__exCleaningGifts) return;
    fetch(base() + 'cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hasBackpack = false, giftKeys = [];
        (cart.items || []).forEach(function (it) {
          if (it.final_price > 0 && /expandura/i.test(it.handle || '')) hasBackpack = true;
          if (it.final_price === 0 && it.properties && it.properties['Geschenk']) giftKeys.push(it.key);
        });
        if (!hasBackpack && giftKeys.length > 0) {
          window.__exCleaningGifts = true;
          var updates = {};
          giftKeys.forEach(function (k) { updates[k] = 0; });
          fetch(base() + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ updates: updates })
          })
            .then(function () { window.__exCleaningGifts = false; render(); })
            .catch(function () { window.__exCleaningGifts = false; });
        }
      })
      .catch(function () {});
  }

  function healErrors() {
    var drawer = drawerEl();
    if (!drawer) return;
    var nodes = drawer.querySelectorAll('#CartDrawer-CartErrors, #cart-errors, .cart-item__error-text');
    var hit = false;
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].textContent && nodes[i].textContent.trim() !== '') {
        nodes[i].textContent = '';
        hit = true;
      }
    }
    if (hit) {
      var now = Date.now();
      if (now - lastHeal > 1500) { lastHeal = now; render(); }
    }
  }

  function observeErrors() {
    var drawer = drawerEl();
    if (!drawer) return;
    try {
      new MutationObserver(function () { healErrors(); })
        .observe(drawer, { childList: true, subtree: true, characterData: true });
    } catch (e) {}
  }

  function classify(u) {
    try {
      if (typeof u !== 'string') return null;
      if (u.indexOf('/cart/add') !== -1) return 'add';
      if (u.indexOf('/cart/change') !== -1) return 'change';
    } catch (e) {}
    return null;
  }

  function onAddDone(hatSections) {
    if (!hatSections) schedule();
    setTimeout(cleanupOrphanGifts, 500);
    melden();
  }

  try {
    var origFetch = window.fetch;
    if (typeof origFetch === 'function') {
      window.fetch = function (input, init) {
        var u = input && input.url ? input.url : input;
        var kind = classify(u);
        if (kind === 'add') {
          // Button lädt; Drawer öffnet erst mit fertigem Inhalt.
          knopfAn();
          init = mitSections(init);
        }
        var pr = origFetch.call(this, input, init);
        if (kind && pr && pr.then) {
          pr.then(function (res) {
            if (!res || !res.ok) { knopfAus(); return; }
            if (kind === 'add') {
              res.clone().json()
                .then(function (j) {
                  var ok = j && j.sections && renderSections(j.sections);
                  if (ok) knopfAus();
                  onAddDone(ok); // ohne sections: schedule() rendert + öffnet + knopfAus
                })
                .catch(function () { onAddDone(false); });
            } else if (kind === 'change') {
              setTimeout(cleanupOrphanGifts, 400);
              melden();
            }
          }).catch(function () { knopfAus(); });
        }
        return pr;
      };
    }
  } catch (e) {}

  try {
    var xhrOpen = XMLHttpRequest.prototype.open;
    var xhrSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      try { this.__exKind = classify(url); } catch (e) {}
      return xhrOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (this.__exKind) {
        var self = this, kind = this.__exKind;
        if (kind === 'add') { knopfAn(); }
        this.addEventListener('load', function () {
          if (self.status >= 200 && self.status < 300) {
            if (kind === 'add') { onAddDone(false); }
            else if (kind === 'change') { setTimeout(cleanupOrphanGifts, 400); melden(); }
          } else {
            knopfAus();
          }
        });
        this.addEventListener('error', function () { knopfAus(); });
      }
      return xhrSend.apply(this, arguments);
    };
  } catch (e) {}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeErrors);
  } else {
    observeErrors();
  }
})();
